export var DocumentEventTypes = /*#__PURE__*/function (DocumentEventTypes) {
  DocumentEventTypes["Accessed"] = "Accessed";
  DocumentEventTypes["Copied"] = "Copied";
  DocumentEventTypes["Created"] = "Created";
  DocumentEventTypes["Deleted"] = "Deleted";
  DocumentEventTypes["Moved"] = "Moved";
  DocumentEventTypes["Restored"] = "Restored";
  DocumentEventTypes["Trashed"] = "Trashed";
  DocumentEventTypes["Updated"] = "Updated";
  return DocumentEventTypes;
}({});
